<ng-container *ngrxLet="selectedPractitioner$ as selectedPractitioner">

  <div class="practitioner-container">
    <mat-icon aria-hidden="false" svgIcon="cuidador"></mat-icon>
    <span class="title">DRT</span>
    <span class="drt">{{ fhirPerformerPractitioner?.drt }}</span>
  </div>

</ng-container>
